import styled from 'styled-components'

import List from '../List'

const Menu = styled(List)``

export default Menu
